<template>
  
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png" />
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="goMore('/finance/index', '首页')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>投资人</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="serch_border"   v-if="options">
    <div class="serchform">
      投资额度：
      <a-tag :class="{'tag-active':invest_limits==''}" @click="postSerchData({invest_limit:''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==invest_limits}" @click="postSerchData({invest_limit:item.dictValue})" v-for="(item,key) in options.invest_limit" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border"  v-if="options">
    <div class="serchform">
      投资领域：
      <a-tag :class="{'tag-active':investmentFields==''}" @click="postSerchData({investmentField:''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==investmentFields}" @click="postSerchData({investmentField:item.dictValue})" v-for="(item,key) in options.investmentField" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="cont_body">
    <div v-for="(item,key) in dataSource" :key="key" @click="goMore('/finance/investor/page','投资人',item.id)" class="list_cont">
      <div class="list_img">
        <img v-if="item.headImg" :src="getImg(item.headImg)" alt="">
        <img v-else src="@/assets/img/userPhoto.jpg" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{ item.investorName }} <span>· <dict-render :dict-obj="dictObjs['position']"
          :text="item.position"></dict-render></span></h4>
        <P>投资领域：
          <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item.investmentField"></dict-render>
        </P>
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import { dictMixin, listMixin } from "@/mixins";
import {financeInvestorWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin, listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      invest_limits: '',// 投资额度
      investmentFields: '',// 投资领域
      financeDict,
      options:null,
      dictNames: 'investmentField,position,invest_limits',
      listUrl: financeInvestorWeb.pageList,
      queryParamFixed: { 
              investmentField: '',
              quota: ''
       },
      current: 1,
      pageSize: 10,
    }
  },
  mounted() {
      this.getDict();
  },
	methods: {
    postSerchData(val){
      if(val.invest_limit||val.invest_limit==''){
        this.queryParamFixed.quota = val.invest_limit
        this.invest_limits = val.invest_limit
      }
      if(val.investmentField||val.investmentField==''){
        this.queryParamFixed.investmentField = val.investmentField
        this.investmentFields = val.investmentField
      }
      this.loadData()
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "invest_limit,investmentField"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 592px;
  margin-bottom: 16px;
  &:nth-child(odd){
    margin-right: 16px;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    flex: 1;
    display: flex;
    align-items: center;
    img{
      width: 107%;
      margin-left: -3px
    }
  }
  .list_cont_body{
    flex: 5;
  }
}
</style>